
import Vue from 'vue'
import LocalStorageSerializer from '@/utils/localStorageSerializer'

import ColorItem from '@/components/ColorItem.vue'

import Const from '@/pages/editor/const'
import { mapGetters } from 'vuex'

export default Vue.extend({
  components: {
    ColorItem
  },
  data() {
    return {
      showPrintableColors: false,
      skuColorId: '',
      bodyTheme: 'sw-Tooltip_Light'
    }
  },
  computed: {
    ...mapGetters(['product']),
    isPrintableSpecialColors() {
      return this.product.sku_printable_special_colors.length
    },
    toggleButtonText() {
      return this.showPrintableColors ? 'Hide printable colors' : 'Show printable colors'
    }
  },
  watch: {
    isPrintableSpecialColors(value) {
      if (!value) this.showPrintableColors = value
    }
  },
  methods: {
    togglePrintableColors() {
      this.showPrintableColors = !this.showPrintableColors
    },
    setCurrentPrintColor(payload) {
      LocalStorageSerializer.set(Const.CURRENT_PRINT_COLOR_KEY, payload)
      this.skuColorId = payload.id
      this.$store.commit('setCurrentPrintColor', payload)
    }
  }
})
